/**
 * @fileoverview Pending two-factor challenge store.
 * @description Holds the email awaiting OTP verification and its code's expiry, hydrated from
 * storage on creation so a page refresh mid-verification doesn't lose it. Mirrors auth.store.ts's
 * shape: set/clear persist to storage as a side effect.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { create } from 'zustand'

import {
  clearStoredTwoFactorChallenge,
  getStoredTwoFactorChallenge,
  setStoredTwoFactorChallenge,
} from '@/shared/lib/auth/token-storage.utils'

import type { TwoFactorChallenge } from '@/shared/lib/auth/auth.types'

interface TwoFactorChallengeState {
  challenge: TwoFactorChallenge | null
  setChallenge: (challenge: TwoFactorChallenge) => void
  clearChallenge: () => void
}

/**
 * @description Zustand store for the pending two-factor challenge.
 * @returns {TwoFactorChallengeState} The current challenge and its set/clear mutators.
 */
export const useTwoFactorChallengeStore = create<TwoFactorChallengeState>((set) => ({
  challenge: getStoredTwoFactorChallenge(),
  setChallenge: (challenge) => {
    setStoredTwoFactorChallenge(challenge)
    set({ challenge })
  },
  clearChallenge: () => {
    clearStoredTwoFactorChallenge()
    set({ challenge: null })
  },
}))
